// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1C7Y_","top":"styles_top__1WERb"};